export default "__VITE_ASSET__DObMiEeS__"